<script setup>
import {computed} from 'vue';

/**
 * Định nghĩa props cho chart
 */
const props = defineProps({
  name: String,
  data: Array,
  title: String,
  height: Number,
  options: Object,
});

// Build series và option cho chart
const series = computed(() => {
  return props.data;
});
const chartOptions = computed(() => {
  return {
    chart: {
      height: props.height,
      type: 'bar',
      toolbar: {
        show: false // Ẩn thanh công cụ
      }
    },
    xaxis: {
      ...props.options?.xaxis,
    },
    yaxis: {
      ...props.options?.yaxis,
    },
    title: {
      text: props.title,
      ...props.options?.title,
    },
    ...props.options.customOptions,
  };
});
</script>
<template>
  <apexchart type="bar" :height="props.height" :options="chartOptions" :series="series"></apexchart>
</template>
